import React from 'react'
import {PROPORTIONAL, proportional} from '../proportional'
import {Group} from 'react-konva'
import {compareElementZ, getGameObjects, getState} from '../game-surface'
import {namespace, register} from '../utils'

function DummySprite() {
    return null
}

let scanner = {}

function getParentSprite(sprite) {
    if (!sprite.parent) return null
    return (
        sprite.parent &&
        sprite.parent.behaviours &&
        sprite.parent.behaviours.instances.sprite &&
        sprite.parent.behaviours.instances.sprite[0]
    )
}

function applyParentTransforms(start) {
    let parent = getParentSprite(start)
    if (parent) {
        let parentScale = (parent?.scale ?? 1) * (parent.document?.scale ?? 1)
        scanner.x *= parentScale
        scanner.y *= parentScale
        scanner.x += parent.x + parent.document.x ?? 0
        scanner.y += parent.y + parent.document.y ?? 0
        applyParentTransforms(parent)
    }
}

const additional = []
const children = []
let lastDt = 0
let returnValues = [
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
]
let currentReturn = 0
export function getReturnValue() {
    return returnValues[currentReturn++ % returnValues.length]
}

export const sprite = register('sprite', {
    priority: -1,
    initialize() {
        this.document.parent = this.document.parent || null
        this.x = this.x ?? 0
        this.y = this.y ?? 0
        this.opacity = this.opacity ?? 1
        this.rotation = this.rotation ?? 0
        this.scale = this.scale ?? 1
        this.document.x = this.document.x ?? 0
        this.document.visible = this.document.visible ?? true
        this.document.y = this.document.y ?? 0
        this.document.scale = this.document.scale ?? 1
        this.document.rotation = this.document.rotation ?? 0
        this.render = { Element: this.Draw }
        this.Sprite = this.Sprite || DummySprite
        this.Sprite = this.Sprite.bind(this)
        const owned = (this.document.owned = this.document.owned || [])
        this.document.transform = this
        this.document.position = () => {
            scanner.x = this.x + this.$.x
            scanner.y = this.y + this.$.y
            applyParentTransforms(this.$)
            const returnValue = getReturnValue()
            returnValue.x = scanner.x
            returnValue.y = scanner.y
            return returnValue
        }
        this.document.addChild = (...children) => {
            for (let child of children) {
                owned.push(child)
                child.parent = this.document
            }
            return children[0]
        }
        this.document.removeChild = (child) => {
            let offset = 0
            for (let scan = 0; scan < owned.length; scan++) {
                if (owned[scan] === child) offset++
                owned[scan] = owned[scan + offset]
            }
            owned.length -= offset
        }
    },
    methods: {
        update() {},
        Update() {},
        draw(elements, dt) {
            lastDt = dt
            this.api.update(dt)
            this.api.Update(dt)
            elements.push(this.render)
        },
        remove() {
            if (this.document.parent) {
                this.document.parent.removeChild(this.document)
            }
            let list = getGameObjects()
            let offset = 0
            for (let scan = 0; scan < list.length; scan++) {
                if (list[scan] === this.document) offset++
                list[scan] = list[scan + offset]
            }
            list.length = list.length - offset
        },
        Draw() {
            if (!this.document.visible) return null
            additional.length = 0
            this.sendMessage('additionalDraw', additional)
            children.length = 0
            for (let child of this.$.owned) {
                child.sendMessage('draw', children, lastDt)
            }
            children.sort(compareElementZ)

            const state = getState()
            const localRotation = this.rotation + this.document.rotation
            let localScale = this.scale * this.document.scale
            const localOpacity =
                (this.document?.opacity ?? 1) * (this.opacity ?? 1)
            PROPORTIONAL.x = this.x + this.document.x
            PROPORTIONAL.y = this.y + this.document.y
            PROPORTIONAL.scaleX = localScale
            PROPORTIONAL.scaleY = localScale
            if (!this.$.parent) {
                proportional(PROPORTIONAL, localScale)
            }
            let position = getReturnValue()
            Object.assign(position, PROPORTIONAL)


            return (
                <Group
                    opacity={localOpacity}
                    rotation={localRotation}
                    {...position}
                >
                    <this.Sprite />
                    {additional.map((Component, index) => (
                        <Component key={index} />
                    ))}
                    {children.map((element, index) => (
                        <element.Element
                            {...element.props}
                            key={`c${index}`}
                            data={namespace(state)}
                            state={state}
                        />
                    ))}
                </Group>
            )
        },
    },
})
